import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

// CREATE VENDOR
export const createVendorEntry = createAsyncThunk(
  "createVendorEntry",
  async (postData) => {
    const response = await axios.post(`${baseUrl}?apicall=insertVendor`, postData);
    return response.data;
  }
);

// UPDATE PARTY
export const updateVendorEntry = createAsyncThunk(
  "updateVendorEntry",
  async (postData) => {
    const response = await axios.post(`${baseUrl}?apicall=updateVendor`, postData);
   // console.log("response=>",response.data);
    return response.data;
  }
);

// FETCH PARTY LIST
export const fetchVendorData = createAsyncThunk(
  "fetchVendorData",
  async () => {
    const response = await axios.get(`${baseUrl}?apicall=getVendorlist`);
   // console.log("response=>",response.data);
    return response.data;
  }
);

// FETCH SINGLE Vendor
export const fetchSingleVendor = createAsyncThunk(
  "fetchSingleVendor",
  async (id) => {
    const response = await axios.get(`${baseUrl}?apicall=getVendorlist&vendorId=${id}`);
    console.log("response=>",response.data);
    return response.data;
  }
);

// DELETE Vendor
export const deleteSingleVendor = createAsyncThunk(
  "deleteSingleVendor",
  async (id) => {
    const response = await axios.delete(`${baseUrl}?apicall=deleteVendor&vendorId=${id}`);
    return response.data;
  }
);

const VendorSlice = createSlice({
  name: "VendorData",
  initialState: {
    isLoading: false,
    vendor: null,
    deleteVendor: null,
    singleVendor: null,
    createVendor: null,
    isError: false,
  },

  extraReducers: (builder) => {

    // CREATE VENDOR
    builder.addCase(createVendorEntry.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(createVendorEntry.fulfilled, (state, action) => {
      state.isLoading = false;
      state.createVendor = action.payload;
    });

    builder.addCase(createVendorEntry.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      console.log("Error", action.error.message);
    });


    // FETCH Vendor LIST
    builder.addCase(fetchVendorData.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchVendorData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.vendor = action.payload;
    });

    builder.addCase(fetchVendorData.rejected, (state, action) => {
      state.isError = true;
      console.log("Error", action.error.message);
    });


    // DELETE PARTY
    builder.addCase(deleteSingleVendor.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(deleteSingleVendor.fulfilled, (state, action) => {
      state.isLoading = false;
      state.deleteVendor = action.payload;
    });

    builder.addCase(deleteSingleVendor.rejected, (state, action) => {
      state.isError = true;
      console.log("Error", action.error.message);
    });


    // FETCH SINGLE PARTY
    builder.addCase(fetchSingleVendor.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchSingleVendor.fulfilled, (state, action) => {
      state.isLoading = false;
      state.singleVendor = action.payload;
    });

    builder.addCase(fetchSingleVendor.rejected, (state, action) => {
      state.isError = true;
      console.log("Error", action.error.message);
    });

  },
});

export default VendorSlice.reducer;